import React from 'react';
import env from 'env';
import { useRouter } from 'components';
import { useGet } from 'components';
import { ErrorPopup } from 'components';
import { getProductEditModel } from './productEditFormModel';
import { ProductEditForm } from './productEditForm';

export function ProductEdit(props) {
  const { query } = useRouter();
  const get = useGet();

  const productCode = query.id || '';

  React.useEffect(() => {
    get.send(env.apiBase + `/api/productAdmin/getProduct/${productCode}`);
    // eslint-disable-next-line
  }, []);

  if (get.loading()) {
    return <div>Loading...</div>
  } else if (get.hasErrors()) {
    return <ErrorPopup title="Loading Error" errors={get.errors} />
  }

  console.log(get)
  const data = get.response;
  const model = getProductEditModel(data);
  //console.log("sfddsfs------", model)

  return <ProductEditForm model={model} data={data} productCode={productCode} />
}